import { Loader2 } from 'lucide-react'
import { cn } from '@/utils'

interface LoadingProps {
  className?: string
  size?: 'sm' | 'md' | 'lg'
  text?: string
}

const sizeMap = {
  sm: 'w-4 h-4',
  md: 'w-8 h-8',
  lg: 'w-12 h-12',
}

export function Loading({ className, size = 'md', text = '加载中...' }: LoadingProps) {
  return (
    <div className={cn('flex flex-col items-center justify-center gap-3', className)}>
      <Loader2 className={cn('animate-spin text-indigo-500', sizeMap[size])} />
      {text && <span className="text-sm text-slate-500">{text}</span>}
    </div>
  )
}

export function LoadingOverlay({ className }: { className?: string }) {
  return (
    <div className={cn('absolute inset-0 bg-white/80 dark:bg-slate-900/80 backdrop-blur-sm flex items-center justify-center z-50', className)}>
      <Loading size="lg" />
    </div>
  )
}

export function LoadingCard({ className }: { className?: string }) {
  return (
    <div className={cn('p-12', className)}>
      <Loading size="md" />
    </div>
  )
}
